import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "field"]
  static values = {
    max: { type: Number, default: 0 },
    fieldName: String
  }

  addField(event) {
    event.preventDefault()
    
    if (this.maxValue > 0 && this.fieldTargets.length >= this.maxValue) {
      alert(`You cannot add more than ${this.maxValue} items`)
      return
    }

    const template = this.fieldTargets[0]
    const clone = template.cloneNode(true)
    const input = clone.querySelector(`input[name*="${this.fieldNameValue}"]`)
    input.value = ''
    
    this.containerTarget.appendChild(clone)
  }

  removeField(event) {
    event.preventDefault()
    const field = event.target.closest('[data-dynamic-fields-target="field"]')
    
    // Don't remove the last field
    if (this.fieldTargets.length > 1) {
      field.remove()
    } else {
      // Clear the last field instead of removing it
      const input = field.querySelector(`input[name*="${this.fieldNameValue}"]`)
      input.value = ''
    }
  }
}